const safeWindow = typeof window !== 'undefined' ? window : undefined;

const getItem = (key: string) => {
  if (!safeWindow) return null;
  return safeWindow.localStorage.getItem(key);
};

const setItem = (key: string, value: string) => {
  if (!safeWindow) return;
  safeWindow.localStorage.setItem(key, value);
};

const removeItem = (key: string) => {
  if (!safeWindow) return;
  safeWindow.localStorage.removeItem(key);
};

const TOKEN_KEY = 'token';
const USER_KEY = 'user';

export const storage = {
  getToken: () => getItem(TOKEN_KEY),
  setToken: (token: string) => setItem(TOKEN_KEY, token),
  clearToken: () => removeItem(TOKEN_KEY),
  getUser: <T>() => {
    const raw = getItem(USER_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return null;
    }
  },
  setUser: (user: unknown) => setItem(USER_KEY, JSON.stringify(user)),
  clearUser: () => removeItem(USER_KEY),
};
